import { render, staticRenderFns } from "./DataTableFilter.vue?vue&type=template&id=460a77e3&scoped=true"
import script from "./DataTableFilter.vue?vue&type=script&lang=ts"
export * from "./DataTableFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a77e3",
  null
  
)

export default component.exports